import { ApolloLink, Observable } from 'apollo-link'
import { omitDeepByUndefined } from '../utils/omitDeepBy'
const pipe = require('lodash/fp/pipe')
const find = require('lodash/fp/find')
const isEqual = require('lodash/fp/isEqual')
const filter = require('lodash/fp/filter')

// Use this function to debug the pipe chain
// on createFindMock
//eslint-disable-next-line
function log(operation) {
  return piped => {
    console.log('Operation: ', operation)
    console.log('Piped element: ', piped)
    return piped
  }
}

const byOperationName = operationName => mock => {
  return mock.operationName === operationName
}

const byExactMatch = (target = {}) => mock => {
  return !mock.variables || isEqual(target, mock.variables)
}

const handleNotFound = operation => mock => {
  if (!mock) {
    throw new Error(
      `Mock not found for operation "${
        operation.operationName
      }"\nVariables:\n${JSON.stringify(operation.variables, null, 2)} \n\n`
    )
  }
  return mock
}

const validateMocks = mocks => {
  mocks.forEach(mock => {
    if (!mock.operationName) {
      throw new Error(
        `You’re missing the "operationName" attribute for one of your mocks.`
      )
    }

    if (!mock.fixture) {
      throw new Error(
        `You forgot to provide the "fixture" attribute for the ${mock.operationName} mock.`
      )
    }
  })

  return mocks
}

const createFindMock = operation => {
  const filteredVariables = omitDeepByUndefined(operation.variables)

  return pipe(
    validateMocks,
    filter(byOperationName(operation.operationName)),
    find(byExactMatch(filteredVariables)),
    handleNotFound(operation)
  )
}

export default class MockLink extends ApolloLink {
  constructor(getMocksFunction) {
    if (typeof getMocksFunction !== 'function')
      throw new Error('You should pass a function to get the mocks')
    super()
    this.getMocks = getMocksFunction
  }

  request(operation) {
    if (!operation.operationName) throw new Error('Operation name required')
    let mockData = null
    const findMock = createFindMock(operation)
    const mock = findMock(this.getMocks())

    // When going from one page to another that has getInitialProps, the fixtures
    // on the window can become undefined. In that case use the fixtures from the folder
    if (
      typeof window !== 'undefined' &&
      typeof window.fixtures !== 'undefined'
    ) {
      mockData = window.fixtures[mock.fixture]
    } else {
      mockData = require(`../cypress/fixtures/${mock.fixture}`) // eslint-disable-line
    }

    return Observable.of(mockData)
  }
}
